import { useMemo } from 'react';
import { CardTypesEnum } from '@common-fe/common-fe';

import { usePlansStore } from '../ExpressSetupWizard/PlansWizard/Plans/stores';

const PLAN_TYPE_ERROR_MESSAGE = 'Choose any plan option or deselect this plan type.';
const PLAN_CODE_TYPE_ERROR = 'planCode';

export interface PlanError {
  type: CardTypesEnum | typeof PLAN_CODE_TYPE_ERROR;
  message?: string;
}
const usePlansFormValidate = () => {
  const plansState = usePlansStore((state) => state.state);

  const plansErrors = useMemo(() => {
    const errors: PlanError[] = [];

    plansState?.planTypes?.forEach((type) => {
      const planExists = plansState?.plans?.some((plan) => plan.type === type);
      if (!planExists) {
        errors.push({ type, message: PLAN_TYPE_ERROR_MESSAGE });
      }
    });

    const planCodeErrorIds: string[] = [];
    plansState?.plans?.forEach((plan) => {
      if (!plan.planCode?.trim()) {
        planCodeErrorIds.push(plan.id);
      }
    });

    if (planCodeErrorIds.length > 0) {
      errors.push({ type: PLAN_CODE_TYPE_ERROR });
    }

    return errors;
  }, [plansState]);

  return plansErrors;
};

export default usePlansFormValidate;
